/**
 * Armazena um valor no localStorage
 * @param {string} key - Chave para armazenamento
 * @param {any} value - Valor a ser armazenado
 */
export const setToStorage = (key, value) => {
  try {
    if (typeof value === 'object') {
      localStorage.setItem(key, JSON.stringify(value));
    } else {
      localStorage.setItem(key, value);
    }
  } catch (error) {
    console.error(`Error storing ${key} in localStorage:`, error);
  }
};

/**
 * Recupera um valor do localStorage
 * @param {string} key - Chave do valor armazenado
 * @param {boolean} parseJson - Se deve fazer parse do JSON (padrão: true)
 * @returns {any} Valor recuperado
 */
export const getFromStorage = (key, parseJson = true) => {
  try {
    const value = localStorage.getItem(key);
    
    if (!value) return null;
    
    if (parseJson) {
      try {
        return JSON.parse(value);
      } catch (error) {
        return value;
      }
    }
    
    return value;
  } catch (error) {
    console.error(`Error retrieving ${key} from localStorage:`, error);
    return null;
  }
};

/**
 * Remove um valor do localStorage
 * @param {string} key - Chave do valor a ser removido
 */
export const removeFromStorage = (key) => {
  try {
    localStorage.removeItem(key);
  } catch (error) {
    console.error(`Error removing ${key} from localStorage:`, error);
  }
};

/**
 * Limpa todos os dados do localStorage
 */
export const clearStorage = () => {
  try {
    localStorage.clear();
  } catch (error) {
    console.error('Error clearing localStorage:', error);
  }
}; 